module.exports = {
	"name": "@splitsoftware/splitio",
	"version": "9.4.0",
	"description": "Split SDK",
	"files": [
		"README.md",
		"lib",
		"types/*.d.ts"
	],
	"repository": "splitio/javascript-client",
	"homepage": "https://github.com/splitio/javascript-client#readme",
	"bugs": "https://github.com/splitio/javascript-client/issues",
	"license": "Apache-2.0",
	"author": "Facundo Cabrera <facundo@split.io>",
	"contributors": [
		{
			"name": "Nico Zelaya",
			"email": "nicolas.zelaya@split.io",
			"url": "https://github.com/NicoZelaya"
		}
	],
	"main": "lib/index.js",
	"types": "types",
	"devDependencies": {
		"babel-cli": "^6.26.0",
		"babel-core": "^6.26.0",
		"babel-eslint": "^7.1.1",
		"babel-loader": "^7.1.2",
		"babel-plugin-istanbul": "^4.1.4",
		"babel-plugin-syntax-object-rest-spread": "^6.13.0",
		"babel-plugin-transform-object-rest-spread": "^6.26.0",
		"babel-plugin-transform-runtime": "^6.15.0",
		"babel-preset-env": "^1.6.0",
		"babel-preset-flow": "6.23.0",
		"copyfiles": "^1.2.0",
		"cross-env": "^5.1.3",
		"csv-streamify": "^3.0.4",
		"eslint": "^4.5.0",
		"eslint-plugin-flowtype": "^2.35.0",
		"fetch-mock": "^5.12.2",
		"karma": "^1.7.1",
		"karma-chrome-launcher": "^2.2.0",
		"karma-coverage": "^1.1.1",
		"karma-firefox-launcher": "^1.0.0",
		"karma-phantomjs-launcher": "~1.0.2",
		"karma-safari-launcher": "^1.0.0",
		"karma-sauce-launcher": "^1.2.0",
		"karma-tap": "^3.0.1",
		"karma-webpack": "^2.0.4",
		"redis-dump": "0.1.10",
		"rimraf": "^2.5.4",
		"tape": "^4.8.0",
		"tape-catch": "^1.0.6",
		"webpack": "^3.5.5"
	},
	"scripts": {
		"build-cjs": "rimraf lib && cross-env BABEL_ENV=cjs babel ./src -d lib --ignore '__tests__'",
		"postbuild-cjs": "node scripts/copy.packages.json.js",
		"build-umd": "cross-env NODE_ENV=development webpack",
		"build-min": "cross-env NODE_ENV=production webpack -p",
		"rebuild": "rimraf lib umd && npm run build-cjs && npm run build-umd && npm run build-min",
		"lint": "eslint src",
		"test-browser-local": "cross-env NODE_ENV=test karma start karma/local.karma.conf.js",
		"test-browser-e2e-local": "cross-env NODE_ENV=test karma start karma/e2e.local.karma.conf.js",
		"test-browser-sauce": "cross-env NODE_ENV=test karma start karma/sauce.karma.conf.js",
		"test-browser-e2e-sauce": "cross-env NODE_ENV=test karma start karma/e2e.sauce.karma.conf.js",
		"test-browser-ci": "cross-env NODE_ENV=test karma start karma/ci.karma.conf.js",
		"test-browser-e2e-ci": "cross-env NODE_ENV=test karma start karma/e2e.ci.karma.conf.js",
		"test-browser-offline": "cross-env NODE_ENV=test karma start karma/offline.karma.conf.js",
		"test-browser-destroy": "cross-env NODE_ENV=test karma start karma/destroy.ci.karma.conf.js",
		"test-node": "tape -r babel-register \"src/*/__tests__/**/!(browser).spec.js\"",
		"test-node-e2e": "tape -r babel-register src/__tests__/destroy/node.spec.js",
		"test-node-offline": "tape -r babel-register src/__tests__/offline/node.spec.js",
		"pretest-node-redis": "cat ./src/__tests__/mocks/redis_mock.json | ./node_modules/redis-dump/bin/cli/redis-dump --convert | redis-cli",
		"test-node-redis": "tape -r babel-register \"src/__tests__/node_redis.spec.js\"",
		"pretest-ts-decls": "npm link",
		"test-ts-decls": "./scripts/ts-tests.sh",
		"posttest-ts-decls": "npm unlink && npm install",
		"canary": "npm run rebuild && npm publish --tag canary",
		"stable": "npm run rebuild && npm publish"
	},
	"dependencies": {
		"@types/node": "^8.0.26",
		"babel-runtime": "^6.26.0",
		"core-js": "^2.5.0",
		"ip": "^1.1.4",
		"isomorphic-fetch": "^2.2.1",
		"lodash": "^4.17.3",
		"logplease": "NicoZelaya/logplease#1.3.0",
		"utfx": "^1.0.1"
	},
	"optionalDependencies": {
		"ioredis": "^2.4.3"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/package.json
// module id = 1296
// module chunks = 10